var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"outlined":"","clearable":"","hide-details":"auto","items":_vm.filteredItems,"small-chips":""},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'v-autocomplete',{ ..._vm.input, ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }